import {
  ExpertsAddedToRecruitmentArea,
  ExpertsRemovedFromRecruitmentArea,
  RecruitmentAreaChanged,
  RecruitmentAreaUpdated,
} from "./types";

export const isRecruitmentAreaUpdated = (
  payload: RecruitmentAreaChanged,
): payload is RecruitmentAreaUpdated =>
  "name" in payload && "cities" in payload;

export const isExpertsAddedToRecruitmentArea = (
  payload: RecruitmentAreaChanged,
): payload is ExpertsAddedToRecruitmentArea => "expertIds" in payload;

export const isExpertsRemovedFromRecruitmentArea = (
  payload: RecruitmentAreaChanged,
): payload is ExpertsRemovedFromRecruitmentArea => "expertIds" in payload;
